// extracted by mini-css-extract-plugin
export default {"button":"XNHl-5O2AaNii40dcSjM4w==","buttonPermalink":"oseXspu83bsnclhOq-kTaQ==","counterText":"DqrQH5mSR3ivDyPUvnwJog=="};